<template>
    <div class="animated fadeIn">
        <table class="kgr-table kgr-table--striped kgr-table--block data-table table-groups printable">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Bereich') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Feld') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="row in createRows()"
                    class="kgr-table__row"
                >
                    <td class="kgr-table__cell">
                        <template v-if="row.showArea">
                            <a
                                v-if="row.area.isEditable"
                                :href="urlForEdit(row.area)"
                                class="kgr-link"
                            >
                                {{ row.area.name }}
                            </a>
                            <div v-else>
                                {{ row.area.name }}
                            </div>
                        </template>
                    </td>
                    <td class="kgr-table__cell">
                        <a
                            v-if="row.area.isEditable && row.field.isEditable"
                            :href="urlForEdit(row.field)"
                            class="kgr-link"
                        >
                            {{ row.field.name }}
                        </a>
                        <div v-else>
                            {{ row.field.name }}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import LocationImageUrlMixin from './LocationImageUrlMixin';

export default {
    name: 'KgrAreasTable',
    mixins: [LocationImageUrlMixin],
    props: {
        areas: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
        },
    },
    methods: {
        createRows() {
            return this.areas.flatMap((area) => {
                return area.fields.flatMap((field, fieldIndex) => {
                    const row = {
                        location,
                        area,
                        field,
                        showArea: fieldIndex === 0,
                    };
                    return this.rowMatchesFilter(row) ? [row] : [];
                });
            });
        },
        rowMatchesFilter(row) {
            if (this.filter === null || this.filter === '') {
                return true;
            }

            const filter = this.filter.toLowerCase().trim();

            if (row.area.name.toLowerCase().includes(filter)) {
                return true;
            }

            if (row.field.name.toLowerCase().includes(filter)) {
                return true;
            }

            return false;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
